import React from 'react'
import { connect } from 'react-redux'
import { string, func, bool } from 'prop-types'
import { toggleStreetView } from '../../../../store/Actions/UiActions'
import StreetViewIcon from '../../../../assets/img/Street_View_logo.png'
import '../styles/StreetViewImage.css'

const StreetViewImage = ({ image, address, toggleStreetView, online }) => (
  <div
    className="street-view-image"
    onClick={() => online && toggleStreetView(true)}
  >
    <img
      src={image}
      alt={`Street view of ${address}`}
      title={`Street view of ${address}`}
    />
    <img
      src={StreetViewIcon}
      alt={`Street view of ${address}`}
      title={`Street view of ${address}`}
      id="streetview-logo-image"
      className="animated jello"
    />
  </div>
)

StreetViewImage.propTypes = {
  image: string.isRequired,
  address: string.isRequired,
  toggleStreetView: func.isRequired,
  online: bool.isRequired,
}

const mapStateToProps = ({ signsState, spi }) => ({
  image: signsState.cache.streetViewImage,
  address: signsState.addressCache,
  online: spi.online,
})

const mapDispatchToProps = dispatch => ({
  toggleStreetView: value => dispatch(toggleStreetView(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(StreetViewImage)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/StreetViewImage/index.jsx